const version:string = "2.1.26";
const versions:string[] = [
    `V${version}`,
    `v${version}`,
    `V.${version}`,
    `v.${version}`
];
export const company:string = "14ninstudio";
export default versions;